import './RatmenRecruitmentToolbar.css'
import {useDispatch, useSelector} from "react-redux";
import {selectSelectedFarmHexKey} from "../../../../../redux/reducers/privateStateReducer/selectors";
import {
  selectIsAgrarianismConversionOn,
  selectUnits
} from "../../../../../redux/reducers/sharedStateReducer/selectors";
import {checkIfFinalRound} from "../../../../../utils/checkIfFinalRound";
import {deselectFarm, distributeSupply, recruitUnit, showToast} from "../../../../../redux/actions";
import ModalButton from "../../../../Modals/ModalWindow/ModalButton/ModalButton";
import React from "react";
import UNIT_TYPES from "../../../../../configs/units";
import {FACTIONS} from "../../../../../constants/factions";
import {createRandomId} from "../../../../../utils/ids/createRandomId";
import {ID_PREFIX_FOR_UNIT} from "../../../../../constants/ids";
import {REGISTRY_SINGLETON} from "../../../../../scenes/Registry";
import {getPlayerUnits} from "../../../../../utils/players/getPlayerUnits";
import {
  checkSameTypeUnitRecruitmentLimit,
  getSameTypeUnitLimit
} from "../../../../../utils/gameState/recruitment/checkSameTypeUnitRecruitmentLimit";
import {
  selectIsParallelSupplyPhase,
  selectSupplyActingPlayer
} from "../../../../../utils/gameState/supply/parallelSupplySelectors";
import {MaskedIcon} from '../../../../coloredIcons/MaskedIcon/MaskedIcon';

const RatmenRecruitmentToolbar = ({withAgrarianism}) => {
  const dispatch = useDispatch();
  const selectedFarmHexKey = useSelector(selectSelectedFarmHexKey);
  // Нанимает игрок, раздающий снабжение: в одновременной фазе снабжения
  // сетевой игры — свой (см. selectSupplyActingPlayer), в поочередной — текущий
  const supplyPlayer = useSelector(selectSupplyActingPlayer);
  const isParallelSupplyPhase = useSelector(selectIsParallelSupplyPhase);
  const isAgrarianismConversionOn = useSelector((state) => selectIsAgrarianismConversionOn(
    state, selectSupplyActingPlayer(state)?.id ?? null
  ));
  const units = useSelector(selectUnits);
  const isFinalRound = useSelector(checkIfFinalRound);

  const handleRecruitD6 = () => {
    if (!supplyPlayer) {
      return;
    }
    // В одновременной фазе найм и снабжение идут за своего игрока явно, в
    // поочередной — без playerId, за текущего игрока, как всегда
    const actionPlayerId = isParallelSupplyPhase ? supplyPlayer.id : undefined;

    // Тот же запрет и тот же текст, что и при найме в фазе войны (см.
    // GameScene): в последнем раунде новые отряды не нанимаются — проверка
    // раньше выбора фермы, иначе игрок сначала получил бы подсказку выбрать
    // ферму ради действия, которое все равно запрещено
    if (isFinalRound) {
      dispatch(showToast('В последнем раунде нельзя нанимать новые отряды!', 'warning', 3000));
      return;
    }

    if (selectedFarmHexKey) {
      const playerUnits = getPlayerUnits(supplyPlayer, units);
      if (!checkSameTypeUnitRecruitmentLimit(supplyPlayer, UNIT_TYPES.D6.id, playerUnits)) {
        const limit = getSameTypeUnitLimit(supplyPlayer, UNIT_TYPES.D6.id);
        dispatch(showToast(`Нельзя иметь более ${limit} отрядов этого типа!`, 'warning', 5000));
        return;
      }

      const isFarmEmpty = !units.some(unit => unit.hexKey === selectedFarmHexKey);

      if (isFarmEmpty) {
        const unitId = createRandomId(ID_PREFIX_FOR_UNIT);

        dispatch(recruitUnit(
          selectedFarmHexKey,
          UNIT_TYPES.D6.id,
          FACTIONS.RATMEN,
          0,
          unitId,
          true,
          actionPlayerId,
        ));
        dispatch(distributeSupply(selectedFarmHexKey, unitId, selectedFarmHexKey, false, false, true, actionPlayerId));
        dispatch(deselectFarm());

        // Проявление отряда на ферме и его звук — см. supplyRecruitAnimationMiddleware
        REGISTRY_SINGLETON.getSoundManager().playDistributeSupply();
      } else {
        dispatch(showToast(`На этой ферме уже находится отряд!`, 'warning', 5000))
      }
    } else {
      dispatch(showToast(`Сначала выберите свободную ферму со снабжением.\n\nЗатем нажмите эту кнопку для найма отряда.`, 'info', 5000));
    }
  }

  if (isAgrarianismConversionOn) {
    return null;
  }

  return (
    <div className={'ratmen-recruitment-toolbar'} style={{marginBottom: withAgrarianism ? 10 : 0}}>
      <ModalButton
        onClick={handleRecruitD6}
        className={'ratmen-recruitment-toolbar_button'}
      >
        <h2>Нанять</h2>
        <MaskedIcon
          className={'ratmen-recruitment-toolbar_icon'}
          src={'/img/icons/d6.png'}
          alt={'Отряд Пехота'}
          title={'Отряд Пехота (макс. размер 6)'}
        />
        <h2>за</h2>
        <img
          className={'ratmen-recruitment-toolbar_icon'}
          src={'/img/icons/supply outline.png'}
          alt={'Снабжение'}
          title={'Снабжение'}
        />
      </ModalButton>
    </div>
  );
};

export default RatmenRecruitmentToolbar;